<template>
  <layouts
    class="test-cv-main-p"
    :total="total"
    :current-page="pageQuery.page"
    :page-size="pageQuery.size"
    @prev-click="prev"
    @next-click="next"
    @current-change="currentChange">
    <template v-slot:sidebar>
      <sidebar/>
    </template>
    <template v-slot:content>

      <!-- 设置在线简历引导 -->
      <div class="guide-in-cv" v-if="!isSetOnlineCv && isNotMentorAndCn">
        <p>超级简历APP已支持HR在线直聊，建议设置在线简历，会获得更多邀约机会，是金子就要闪闪发光！</p>
        <button @click="$router.push({name: 'Cvs', params: {from_inbox: true}})">立即设置</button>
      </div>

      <!-- new PC inbox -->
      <div class="inbox-wrapper">

        <div class="inbox-header">
          <span class="header-title">HR邀约通知</span>
          <span class="header-text">共收到{{total}}条邀约信息</span>
        </div>

        <!-- 占位图 -->
        <skeleton :options="{moduleCount: 4, count: 4}" v-if="isLoading"/>

        <div class="inbox-body" v-if="total > 0 && !isLoading">

          <template v-for="(item, index) in applies">

            <!-- 普通 类型卡片 -->
            <div class="inbox-item" :key="'inbox-item' + index" v-if="!item.contact">

              <div class="inbox-item-top" @click="toEdit(item)">
                <div class="job-info">
                  <p class="job-name">{{item.job_post}}</p>
                  <div class="job-desc">
                    <span class="salary">{{(item.annual_month_salary && item.annual_month_salary > 12) ? `${item.job_salary} · ${item.annual_month_salary}薪` : `${item.job_salary}`}}</span>
                    <p class="text">{{item.city}}<span class="vline"></span>{{item.display_experience}}
                      <template v-if="item.degree">
                        <span class="vline"></span>{{item.degree}}
                      </template>
                    </p>
                  </div>
                  <div class="job-tag">
                    <template v-for="(tagName, tagIndex) in item.job_tags">
                      <span class="tag" :key="'inbox-item-tag' + tagIndex">{{tagName}}</span>
                    </template>
                  </div>
                </div>
                <div class="company-info">
                  <div class="company-desc">
                    <p class="company-name">{{item.company_nick_name}}</p>
                    <p class="company-text">{{item.company_industry}}<span class="vline"></span>{{item.company_nature}}<span class="vline"></span>{{item.company_scale}}</p>
                  </div>
                  <div class="company-logo">
                    <img :src="item.company_logo" alt="">
                  </div>
                </div>
              </div>

              <div class="inbox-item-bottom">
                <div class="inviter-info">
                  <img :src="item.hr_avatar" alt="" class="inviter-avatar">
                  <div class="inviter-desc">
                    <p class="desc-top">
                      <span class="inviter-name">{{item.hr_name}}</span>
                      <span class="vline"></span>
                      <span class="inviter-position">{{item.hr_company_position}}</span>
                      <span class="inviter-time">{{item.apply_at}}</span>
                    </p>
                    <div class="desc-bottom">
                      <p class="text">{{item.apply_msg}}</p>
                      <div class="handle-box">
                        <button v-if="item.status === 'applied'" class="handle-button rejected" @click.stop="submit(item.id, 'rejected', index)">不感兴趣</button>
                        <button v-if="item.status === 'applied'" class="handle-button passed" @click.stop="submit(item.id, 'passed', index)">可以聊</button>
                        <button v-if="item.status === 'passed'" class="handle-button continue" @click="dialogMobileVisible = true">继续沟通</button>
                        <button v-if="item.status === 'rejected'" class="lose-interest-in">对该职位不感兴趣</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <!-- 极速联系 类型卡片 -->
            <div class="inbox-item contact" :key="'inbox-item' + index" @click="toEdit(item)" v-else>

              <div class="inbox-item-bottom">
                <div class="inviter-info">
                  <img :src="item.hr_avatar" alt="" class="inviter-avatar">
                  <div class="inviter-desc">
                    <p class="desc-top">
                      <span class="inviter-name">{{item.hr_name}}</span>
                      <span class="vline"></span>
                      <span class="inviter-position">{{item.hr_company_position}}</span>
                      <span class="inviter-time">{{item.apply_at}}</span>
                    </p>
                    <div class="desc-bottom">
                      <p class="text">查看了您的简历</p>
                    </div>
                  </div>
                </div>
                <div class="company-info">
                  <div class="company-desc">
                    <p class="company-name">{{item.company_nick_name}}</p>
                    <p class="company-text">{{item.company_industry}}<span class="vline"></span>{{item.company_nature}}<span class="vline"></span>{{item.company_scale}}</p>
                  </div>
                  <div class="company-logo">
                    <img :src="item.company_logo" alt="">
                  </div>
                </div>
              </div>

            </div>

          </template>

        </div>

        <div class="no-data" v-if="total <= 0 && !isLoading">
          <div class="no-data-content">
            <img class="placeholder" src="https://files.wondercv.com/pc-inbox/%E5%8D%A0%E4%BD%8D%E5%9B%BE%402x.png" alt="">
            <p class="desc">暂无HR邀约记录，或许可以先看看机会？</p>
            <button class="button" @click="$router.push('/jobs/recommend')">去看职位</button>
          </div>
        </div>

      </div>

      <!-- 下载弹窗 -->
      <div class="mobile-alert" v-show="dialogMobileVisible" @mousewheel.prevent>
        <div class="mobile-alert-cover" @click="dialogMobileVisible=!dialogMobileVisible"></div>
        <div class="mobile-alert-content">
          <h6>下载 APP</h6>
          <span>扫码下载APP，随时随地和HR在线直聊</span>
          <img src="https://files.wondercv.com/appDownloadIcon.png" alt="">
        </div>
      </div>




      <div class="test-cv-main" v-if="applies.length && false">
        <div class="title font_w_b f_18 color_40">HR 邀约通知</div>
        <div class="tabel">
          <div class="tabel-header clearfix color_40">
            <div class="fl f_16 text_center tabel-box1">负责人</div>
            <div class="fl f_16 text_center tabel-box2">公司｜职位</div>
            <div class="fl f_16 text_center tabel-box3">时间</div>
            <div class="fl f_16 text_center tabel-box4">状态</div>
          </div>
          <div class="tabel-item clearfix f_16 color_40">
            <div class="list cursor_p" v-for="(item, index) in applies" :key="String(index)" @click="toEdit(item)">
              <div class="flex-c">
                <div class="flex1">
                  <div class="flex-c">
                    <div class="tabel-cont-box1 clearfix">
                      <img class="fl" :src="item.hr_avatar || headImgList.round[index%3]" alt="">
                      <div class="fl name ellipsis f_16 color_40">{{item.hr_name}}</div>
                      <span class="fl iconfont iconpinglun color_90" @click.stop="showMsg(index)"></span>
                    </div>
                    <div class="tabel-cont-box2 text_center ellipsis">
                      <!-- <div class="company_name pr f_14 color_60 flex1 ellipsis">{{item.company}}</div>
                      <div class="positoin f_14 color_90 ellipsis">{{item.positoin}}</div> -->
                      <span class="company_name pr f_14 color_60 transition_all">{{item.company_nick_name || item.company_name}}</span>
                      <span class="f_14 color_60" v-if="(item.company_nick_name || item.company_name) && item.positoin"> | </span>
                      <span class="positoin f_14 color_90">{{item.positoin}}</span>
                    </div>
                    <div class="flex1 tabel-cont-box3 text_center f_14 color_90">
                      {{item.apply_at}}
                    </div>
                  </div>
                  <!-- 申请消息 -->
                  <div class="apply_msg f_14 color_60" v-show="(item.status === 'applied' || item.showMsg) && item.apply_msg">
                    <div class="text">{{item.apply_msg}}</div>
                  </div>
                </div>
                <!-- 右侧操作按钮或申请状态 -->
                <div class="tabel-cont-box4 text_center f_14 color_90">
                  <template v-if="item.status === 'applied'">
                    <!-- 特定这几个人不允许操作 -->
                    <template v-if="!rootUserId[_c_t]">
                      <div class="pass bg_red color_fff cursor_p" @click.stop="submit(item.id, 'passed', index)">可以聊 </div>
                      <div class="reject cursor_p color_90" @click.stop="submit(item.id, 'rejected', index)">不感兴趣</div>
                    </template>
                    <!-- 只有几个管理员才能看到这个 -->
                    <span class="rejected" v-else>-</span>
                  </template>

                  <template v-else>
                    <span class="rejected" v-if="item.contact">已查看</span>
                    <span class="rejected" v-else-if="item.status === 'rejected'">不感兴趣</span>
                    <span class="passed" v-else>已接受</span>
                  </template>
                </div>
              </div>
              
              <!-- 艾雪：cv048a3f5c54c34edb -->
              <!-- tommy：cv464d97270104430e -->
              <!-- kevin：cv74bf5becff854bae -->
              <div class="f_14 color_60" v-if="!!rootUserId[_c_t]">
                <div>cv_token：{{item.cv_token}}</div>
                <div>cv：{{item.cv_update_at}}</div>
                <div>resume：{{item.resume_update_at}}</div>
                <div v-if="item.status==='rejected'">拒绝原因：{{item.reject_reason}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <default-page v-if="!applies.length && !isRequest">暂无简历申请数据</default-page> -->
      <cvsAlert :alertData="alertData" @close="alertClose" :updatedType="updatedType"/>
    </template>
  </layouts>
</template>
<script>
import api from '@/api'
import { mapState } from 'vuex'
import { dealSignatrue, auth, get_tUser } from '@/assets/js/util'

import layouts from '@/components/base/layouts'
import sidebar from '@/components/base/sidebar'
import defaultPage from '@/components/base/default'
import skeleton from '@/components/base/skeleton'
import cvsAlert from '@/views/cvs/components/alert'
import {ioMixin} from "../../assets/js/io";


export default {
  name: 'test',
  layout: 'notTop',
  mixins: [ioMixin],
  components: {
    layouts,
    sidebar,
    defaultPage,
    skeleton,
    cvsAlert
  },
  computed: {
    ...mapState('me', ['publicKey']),
    ...mapState('cv', ['cvs',])
  },
  data() {
    return {
      dialogMobileVisible: false, // 下载弹框
      isSetOnlineCv: true, // 用户是否有设置在线简历
      isNotMentorAndCn: false, // 用户是否有非导师中文简历
      isLoading: true, // 是否显示占位图

      data: [1, 2, 3, 4],
      applies: [],
      new_apply_count: 0,
      total: 0,
      pageQuery: {
        size: 10,
        page: 1,
        is_inbox: true
      },
      isRequest: true,
      _c_t:'',
      headImgList: { //头像
        round:['https://files.wondercv.com/taro_searchResume_miniprogram/headImg_round1.png','https://files.wondercv.com/taro_searchResume_miniprogram/headImg_round2.png','https://files.wondercv.com/taro_searchResume_miniprogram/headImg_round3.png'], // 圆图
        square:['https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square1.png','https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square2.png','https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square3.png'], // 方图
      },
      rootUserId:{ //超级管理员用户
        'cv048a3f5c54c34edb':true, //艾雪
        'cv464d97270104430e':true, //tommy
        'cv74bf5becff854bae':true, //kevin
        'cva9f238978a8e4e70':true, //明慧
        'cv54400cf489db4904':true, //光宝
        'cvd2e85c14930441d7':true, //杨雪
        'cvd34140b6c5cd4760':true, //桂敏
        'cv9dfa0614ffc9458a':true, //lusi
      },
      alertData: {
        show: false,
        type: ''
      },
      updatedType: 'new',
    }
  },
  watch: {
    cvs: {
      deep: true,
      immediate: true,
      handler (cvs) {
        this.checkCvs(cvs) // 检查 用户是否有 非导师中文简历
      }
    },
    new_apply_count: {
      keep: true,
      immediate: true,
      handler(val) {
        this.$store.dispatch('app/setSidebarNum', val)
      }
    }
  },
  async created() {
    await auth();
    this.$store.dispatch('cv/getCvsList'); // 获取 用户简历列表
    this.$store.dispatch('app/setSidebar', 'HR 邀约');
    this.isRequest = true,
    this.getList();
  },
  async mounted(){
    //拿到c端用户
    let tUser = get_tUser();
    this._c_t = tUser.c_t || '';
    this.getOnlineCvInfo()

    // await this.$store.dispatch('cvs/getCvs');
  },
  methods: {
    alertClose() {
      this.alertData.show = false;
      setTimeout(() => {
        this.getData();
      }, 100);
    },
    // 是否存在非导师中文简历
    checkCvs (cvArray) {
      if (!cvArray || cvArray.length === 0) return false
      cvArray.forEach(item => {
        if (!item.is_mentor && item.lang === 'cn') {
          this.isNotMentorAndCn = true
        }
      })
    },
    // 是否设置在线简历
    async getOnlineCvInfo () {
      let res = await api.cvsV2.getOnlineCv(this._c_t) // code === 80120 未设置在线简历
      console.log(res)
      if (res.code === 80120) {
        this.isSetOnlineCv = false
      } else {
        this.isSetOnlineCv = true
      }
    },
    async getList() {
      let res = await api.test.allApply(this.pageQuery);
      if (res.code === 1000) {
        let { resume_hr_permissions, new_resume_hr_permission_count, resume_hr_permission_count } = res.data;

        // 模拟增加数据
        // resume_hr_permissions[0].status = 'applied'

        resume_hr_permissions && resume_hr_permissions.forEach(item=>{
          item.showMsg = false;
        })
        this.applies = resume_hr_permissions || [];
        this.new_apply_count = new_resume_hr_permission_count || 0;
        this.total = resume_hr_permission_count || 0;
        this.isLoading = false
      } else {
        this.applies = []
        this.new_apply_count = 0
        this.total = 0
        this.isLoading = false
        // this.$message.error('请求出错')
      }
      this.isRequest = false;
    },
    async submit(id, type, index) {
      let query = {
        permission_id: id,
        operation: type
      };
      if (type === 'rejected') {
        let alertData = {
          show: true,
          type: 'inboxNo',
          confirm: res => {
            query.reason = res.reason;
            this.submitApi(query, index, type)
          }
        };
        this.$store.dispatch('app/setAlertData', alertData);
      } else {
        this.submitApi(query, index, type)
      }
      
    },
    async submitApi(query, index, type) {
      let params = {
        operation: query.operation,
        reason: query.reason,
      };
      await api.test.applyOperate(query.permission_id, params)
        .then(res => {
          if (res.code === 1000) {
            this.reportedData({
              data_type: 'job_invite',
              data: {
                permission_ids: [ query.permission_id ],
                operation: type
              }
            })
            if (type === 'passed') {
            }
            let applies = this.applies;
            applies[index].status = query.operation;
            this.applies[index].showMsg = false;
            this.new_apply_count--;
            if (type === 'passed') {
              this.$message.success('已接受 HR 邀约，下载超级简历 APP 即可与 HR 在线聊天')
            } else if (type === 'rejected') {
              this.$message.success('已拒绝申请')
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          this.$message.error('服务器出错')
        })
    },
    prev() {
      this.pageQuery.page--;
      this.getList();
    },
    next() {
      this.pageQuery.page++;
      this.getList();
    },
    currentChange(page) {
      this.pageQuery.page = page;
      this.getList();
    },
    //点击是否展示申请描述
    toEdit(item){
      window.open(`${item.job_token ? `/jobs/${item.job_token}.html` : `/company/${item.company_token}.html`}`)
      // this.applies[index].showMsg = !this.applies[index].showMsg
    },
    //点击是否展示申请描述
    showMsg(index){
      this.applies[index].showMsg = !this.applies[index].showMsg
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "./index.scss";
</style>

<style lang="scss" scoped>
  // 公共初始化样式
  @import '@/assets/css/public';
  .tabel{
    .tabel-header{
      line-height: 66px;
      border-bottom: 1px solid #EEF0F5;
      .tabel-box1{
        width: 190px;
      }
      .tabel-box2{
        width: 290px;
      }
      .tabel-box3{
        width: 168px;
      }
      .tabel-box4{
        width: 180px;
      }
    }

    .tabel-item{
      // height: 65px;
      .list{
        border-bottom: 1px solid #EEF0F5;
        &:hover{
          background: #fbfbfb;
        }
      }
      .tabel-cont-box1{
        box-sizing: border-box;
        width: 190px;
        height: 65px;
        padding-left: 24px;
        padding-top: 18px;
        img{
          width: 28px;
          height: 28px;
          object-fit: cover;
        }
        .name{
          max-width: 64px;
          margin: 0 16px 0 8px;
          line-height: 28px;
        }
        .iconfont{
          line-height: 28px;
        }
      }
      .tabel-cont-box2{
        box-sizing: border-box;
        width: 290px;
        padding: 0 15px;
        height: 65px;
        .company_name{
          // padding-right: 15px;
          // text-align: right;
          height: 65px;
          line-height: 65px;
          &:hover{
            color: #FF4F4C;
          }
          // &:before{
          //   content:'|';
          //   display: block;
          //   width: 15px;
          //   height: 65px;
          //   text-align: center;
          //   position: absolute;
          //   right: 0;
          //   top: 0;
          // }
        }
        .positoin{
          // width: 78px;
          // text-align: left;
        }
      }
      .tabel-cont-box3{
        box-sizing: border-box;
        width: 168px;
        height: 65px;
        line-height: 65px;
      }
      .tabel-cont-box4{
        box-sizing: border-box;
        width: 180px;
        min-height: 45px;
        line-height: 45px;
        padding: 10px 0;
      }
    }
    .reject{
      width: 70px;
      height: 28px;
      line-height: 28px;
      border:1px solid #909090;
      border-radius: 2px;
      margin: 0 auto;
      &:hover{
        color:#404040;
        border-color: #606060;
      }
    }
    .pass{
      margin: 0 auto 10px;
      width: 72px;
      height: 30px;
      line-height: 30px;
      border-radius: 2px;
      &:hover{
        opacity: 0.8;
      }
    }
    .apply_msg{
      padding: 0 0 20px 24px;
      .text{
        width: 530px;
        padding: 5px 10px;
        line-height: 20px;
        background: #F6F6F6;
        border-radius:2px;
      }
    }
  }
  .test-cv-main-p {
    margin-bottom: 80px;
    /*padding-top: 80px;*/
  }
  .test-cv-main {
    width: 900px;
    background: #fff;
    padding: 25px 36px;
    padding-bottom: 64px;
    box-sizing: border-box;
    .title {
      font-family:PingFangSC-Medium,PingFang SC;
    }

    /*button {
      width: 72px;
      height: 30px;
      border: 1px solid #dcdcdc;
      color: #909090;
      font-size: 14px;
      background: #fff;
      border-radius: 2px;
      &.action {
        background: #FF4F4C;
        border-color: #FF4F4C;
        color: #fff;
      }
      &:last-child {
        margin-left: 14px;
      }
    }*/
  }
</style>

<style lang="scss">
  .test-cv-main {
    .table-header {
      font-size: 14px;
      .table-column {
        color: #404040;
        font-size: 14px;
      }
    }
    .table-column {
      height: 62px;
      border-color: #EEEEEE;
      color: #909090;
      font-size: 14px;
      &:first-child {
        width: 200px;
      }
    }
    .table-name {
      max-width: 100%;
      color: #404040;
      position: relative;
      width: fit-content;
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex: 1;
      .table-img {
        width: 28px;
        height: 28px;
        border-radius: 14px;
        overflow: hidden;
        position: relative;
        margin-right: 12px;
        flex: none;
        img {
          // max-width: 100%;
          // max-width: 100%;
          width: 100%!important;
          height: 100%!important;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }
      }
      &>div {
        width: calc(100% - 28px - 12px);
      }
      &.flag::after {
        content: "";
        display: block;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #FF4F4C;
        position: absolute;
        top: 2px;
        right: -6px;
      }
    }
    .table-status {
      max-width: 230px;
    }
    .rejected {
      font-size: 14px;
      color: #909090;
    }
    .passed {
      font-size: 14px;
      color: #4183FF;
    }
    tr:hover {
      background: #fff;
      .table-column {
        background: #fff!important;
      }
    }
  }
 
</style>
